import SafariStub from "../SafariStub";

function SouthernCircuits() {
  return (
    <SafariStub
      title="Southern Circuit"
      lead="Wilder parks with fewer vehicles. Ruaha big landscapes, Nyerere rivers, and Mikumi for easier southern access."
      points={[
        "Quieter than the northern parks in most months",
        "Strong for travelers who want space and remote bush",
        "Works as a standalone safari or before Zanzibar",
      ]}
      parentTo={"/safaris"}
      parentLabel="Safaris"
    />
  );
}

export default SouthernCircuits;
